import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import products from "../data/products"; // Adjust this path as needed
import "../css/Breadcrumbs.css";

const Breadcrumbs = () => {
  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  useEffect(() => {
    const paths = location.pathname.split("/").filter((path) => path);

    const breadcrumbPaths = paths.map((path, index) => {
      const currentPath = paths.slice(0, index + 1).join("/");

      // Try to parse path as ID and match with a product
      const productMatch = !isNaN(path) && products.find(p => p.id === parseInt(path));

      const name = productMatch
        ? productMatch.name.toUpperCase()
        : decodeURIComponent(path).replace(/-/g, " ").toUpperCase();

      return {
        name,
        link: `/${currentPath}`,
      };
    });

    setBreadcrumbs([{ name: "HOME", link: "/" }, ...breadcrumbPaths]);
  }, [location]);

  return (
    <div className="breadcrumbs">
      {breadcrumbs.map((breadcrumb, index) => (
        <span key={index} className="breadcrumb-item">
          <Link to={breadcrumb.link} className="router-link">
            {breadcrumb.name}
          </Link>
          {index < breadcrumbs.length - 1 && <span className="separator"> &gt; </span>}
        </span>
      ))}
    </div>
  );
};

export default Breadcrumbs;
